export default __webpack_public_path__ + "static/xlSilverDetail-f24901eab48ca48ed004cea6d4a9e9f0.png";